<div #scrollContainer class="scroll-container" (wheel)="onWheel($event)" (scroll)="onScroll()"
    (scrollend)="onScrollEnd()">
    <div id="linear-gradient">
        <app-landing-page #landingPage></app-landing-page>
        <app-why-me #whyMe></app-why-me>
        <app-my-skill-set #mySkills></app-my-skill-set>
        <app-my-work #myWork></app-my-work>
        <app-references #references></app-references>
        <app-contact #contactSection></app-contact>
        <app-end-block #endBlock></app-end-block>
    </div>
</div>